import { defineMessages } from 'react-intl.macro';

import { RouteId } from './routes';

export const linkMessages = defineMessages<RouteId>({
  error: {
    id: 'link.error',
    defaultMessage: 'Ouha',
  },
  docDetail: {
    id: 'link.docDetail',
    defaultMessage: 'Detail',
  },
  docCheck: {
    id: 'link.docCheck',
    defaultMessage: 'Kontrola',
  },
  docInitialImport: {
    id: 'link.docInitialImport',
    defaultMessage: 'Prvotní import dat',
  },
  docPodaniDTI: {
    id: 'link.docPodaniDTI',
    defaultMessage: 'Podání DTI',
  },
  checkList: {
    id: 'link.checkList',
    defaultMessage: 'Přehled kontrol',
  },
  docList: {
    id: 'link.docList',
    defaultMessage: 'Přehled dokumentací',
  },
  prejimkaHome: {
    id: 'link.prejimkaHome',
    defaultMessage: 'Přejímka',
  },
  signup: {
    id: 'link.signup',
    defaultMessage: 'Zaregistrovat se',
  },
  prejimkaDocList: {
    id: 'link.prejimkaDocList',
    defaultMessage: 'Přehled přejímek',
  },
  prejimkaDocNew: {
    id: 'link.prejimkaDocNew',
    defaultMessage: 'Nová přejímka',
  },
  prejimkaDocDetail: {
    id: 'link.prejimkaDocDetail',
    defaultMessage: 'Detail',
  },
  prejimkaNewCheck: {
    id: 'link.prejimkaNewCheck',
    defaultMessage: 'Kontrola dokumentace',
  },
  prejimkaCheckDetail: {
    id: 'link.prejimkaCheckDetail',
    defaultMessage: 'Kontrola dokumentace',
  },
  prejimkaCheckList: {
    id: 'link.prejimkaCheckList',
    defaultMessage: 'Přehled kontrol',
  },
  prejimkaUserList: {
    id: 'link.prejimkaUserList',
    defaultMessage: 'Přehled uživatelů',
  },
  prejimkaUserEdit: {
    id: 'link.prejimkaUserEdit',
    defaultMessage: 'Uživatel',
  },
  prejimkaOrganizationList: {
    id: 'link.prejimkaOrganizationList',
    defaultMessage: 'Přehled organizací',
  },
  prejimkaNewOrganization: {
    id: 'link.prejimkaNewOrganization',
    defaultMessage: 'Nová organizace',
  },
  prejimkaOrganization: {
    id: 'link.prejimkaOrganization',
    defaultMessage: 'Organizace',
  },
  initialImportDocDetail: {
    id: 'link.initialImportDocDetail',
    defaultMessage: 'Prvotní import dat',
  },
  podaniDTINew: {
    id: 'link.podaniDTINew',
    defaultMessage: 'Podání DTI',
  },
  podaniDTIDetail: {
    id: 'link.podaniDTIDetail',
    defaultMessage: 'Podání DTI',
  },
  dmvsDtiDetail: {
    id: 'link.dmvsDtiDetail',
    defaultMessage: 'Příjem prvků DTI',
  },
  dmvsGadDetail: {
    id: 'link.dmvsGadDetail',
    defaultMessage: 'Příjem prvků GAD',
  },
  managerHome: {
    id: 'link.managerHome',
    defaultMessage: 'Manažer',
  },
  managerDocList: {
    id: 'link.managerDocList',
    defaultMessage: 'Přehled dokumentací',
  },
  managerDocFilter: {
    id: 'link.managerDocFilter',
    defaultMessage: 'Filtrování dokumentace',
  },
  managerNewCheck: {
    id: 'link.managerNewCheck',
    defaultMessage: 'Kontrola dokumentace',
  },
  managerCheckDetail: {
    id: 'link.managerCheckDetail',
    defaultMessage: 'Kontrola dokumentace',
  },
  managerCheckList: {
    id: 'link.managerCheckList',
    defaultMessage: 'Přehled kontrol',
  },
  managerUserList: {
    id: 'link.managerUserList',
    defaultMessage: 'Přehled uživatelů',
  },
  managerUserEdit: {
    id: 'link.managerUserEdit',
    defaultMessage: 'Uživatel',
  },
  managerOrganizationList: {
    id: 'link.managerOrganizationList',
    defaultMessage: 'Přehled organizací',
  },
  managerNewOrganization: {
    id: 'link.managerNewOrganization',
    defaultMessage: 'Nová organizace',
  },
  managerOrganization: {
    id: 'link.managerOrganization',
    defaultMessage: 'Organizace',
  },
  managerSubjectList: {
    id: 'link.managerSubjectList',
    defaultMessage: 'Přehled subjektů',
  },
  managerSubjectDetail: {
    id: 'link.managerSubjectDetail',
    defaultMessage: 'Detail subjektu',
  },
  managerGeodesistList: {
    id: 'link.managerGeodesistList',
    defaultMessage: 'Přehled geodetů',
  },
  managerGeodesistDetail: {
    id: 'link.managerGeodesistDetail',
    defaultMessage: 'Detail geodeta',
  },
  managerSvuList: {
    id: 'link.managerSvuList',
    defaultMessage: 'Přehled SVÚ oblastí',
  },
  managerSvuDetail: {
    id: 'link.managerSvuDetail',
    defaultMessage: 'Detail SVÚ oblasti',
  },
  managerNewSvu: {
    id: 'link.managerNewSvu',
    defaultMessage: 'Nová SVÚ oblast',
  },
  managerEpsi: {
    id: 'link.managerEpsi',
    defaultMessage: 'Aktualizace EPSI',
  },
  managerEpsiDetail: {
    id: 'link.managerEpsiDetail',
    defaultMessage: 'Detail aktualizace EPSI',
  },
  vydejHome: {
    id: 'link.vydejHome',
    defaultMessage: 'Výdej',
  },
  vydejUserDetail: {
    id: 'link.vydejUserDetail',
    defaultMessage: 'Uživatel',
  },
  vydejOrderList: {
    id: 'link.vydejOrderList',
    defaultMessage: 'Přehled žádostí o data',
  },
  vydejNewOrder: {
    id: 'link.vydejNewOrder',
    defaultMessage: 'Nová žádost o data',
  },
  vydejNewOrderSuccess: {
    id: 'link.vydejNewOrderSuccess',
    defaultMessage: 'Nová žádost o data vytvořena',
  },
  vydejOrderDetail: {
    id: 'link.vydejOrderDetail',
    defaultMessage: 'Detail žádosti o data',
  },
  vydejOrderEdit: {
    id: 'link.vydejOrderEdit',
    defaultMessage: 'Editace žádosti o data',
  },
  vydejEpsiOrderList: {
    id: 'link.vydejEpsiOrderList',
    defaultMessage: 'Přehled žádostí o výdej EPSI',
  },
  vydejEpsiOrderDetail: {
    id: 'link.vydejEpsiOrderDetail',
    defaultMessage: 'Detail žádosti o výdej EPSI',
  },
  vydejPublishsetList: {
    id: 'link.vydejPublishsetList',
    defaultMessage: 'Přehled výdejních sad',
  },
  vydejNewPublishset: {
    id: 'link.vydejNewPublishset',
    defaultMessage: 'Nová výdejní sada',
  },
  vydejPublishsetDetail: {
    id: 'link.vydejPublishsetDetail',
    defaultMessage: 'Editace výdejní sady',
  },
  vydejNewTag: {
    id: 'link.vydejNewTag',
    defaultMessage: 'Nový štítek',
  },
  vydejTagDetail: {
    id: 'link.vydejTagDetail',
    defaultMessage: 'Detail štítku',
  },
  vydejTagList: {
    id: 'link.vydejTagList',
    defaultMessage: 'Přehled štítků',
  },
  vydejDatasourceList: {
    id: 'link.vydejDatasourceList',
    defaultMessage: 'Přehled datových zdrojů',
  },
  vydejExportToolList: {
    id: 'link.vydejExportToolList',
    defaultMessage: 'Přehled exportních nástrojů',
  },
  vydejNewExportTool: {
    id: 'link.vydejNewExportTool',
    defaultMessage: 'Nový exportní nástroj',
  },
  vydejPriceList: {
    id: 'link.vydejPriceList',
    defaultMessage: 'Přehled ceníku',
  },
  vydejNewPriceListItem: {
    id: 'link.vydejNewPriceListItem',
    defaultMessage: 'Nová položka ceníku',
  },
  vydejPriceListItemDetail: {
    id: 'link.vydejPriceListItemDetail',
    defaultMessage: 'Detail položky ceníku',
  },
  vydejServiceOrderList: {
    id: 'link.vydejServiceOrderList',
    defaultMessage: 'Přehled žádostí bez exportu',
  },
  vydejNewServiceOrder: {
    id: 'link.vydejNewServiceOrder',
    defaultMessage: 'Nová žádost bez exportu',
  },
  vydejServiceOrderDetail: {
    id: 'link.vydejServiceOrderDetail',
    defaultMessage: 'Detail žádosti bez exportu',
  },
  vydejExportToolDetail: {
    id: 'link.vydejExportToolDetail',
    defaultMessage: 'Detail exportního nástroje',
  },
  vydejChartDoc: {
    id: 'link.vydejChartDoc',
    defaultMessage: 'Statistika žádostí o data',
  },
  ceproDocNew: {
    id: 'link.ceproDocNew',
    defaultMessage: 'ČEPRO import dat',
  },
  ceproDocDetail: {
    id: 'link.ceproDocDetail',
    defaultMessage: 'ČEPRO import dat',
  },
  bbDocNew: {
    id: 'link.bbDocNew',
    defaultMessage: 'Import dat',
  },
  bbDocDetail: {
    id: 'link.bbDocDetail',
    defaultMessage: 'Import dat',
  },
  podaniKADNew: {
    id: 'link.podaniKADNew',
    defaultMessage: 'Podání KAD',
  },
  podaniKADDetail: {
    id: 'link.podaniKADDetail',
    defaultMessage: 'Podání KAD',
  },
});
